import React from 'react';
import { Helmet } from 'react-helmet-async';

interface EventData {
  name: string;
  description: string;
  url: string;
  image: string;
  startDate: string;
  endDate: string;
  performer: string;
  priceRange: string;
  eventStatus: string;
}

interface Props {
  event: EventData;
}

const EventLocalBusinessSchema: React.FC<Props> = ({ event }) => {
  const priceMatch = event.priceRange.match(/[0-9]+/);
  const price = priceMatch ? priceMatch[0] : '0';

  const data = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        "name": "Cats About Town Tours",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "New York",
          "addressRegion": "NY",
          "addressCountry": "US"
        },
        "priceRange": event.priceRange,
        "url": "https://catsabouttowntours.com"
      },
      {
        "@type": "Event",
        "name": event.name,
        "description": event.description,
        "url": event.url,
        "image": `https://catsabouttowntours.com${event.image}`,
        "startDate": event.startDate,
        "endDate": event.endDate,
        "eventStatus": event.eventStatus,
        "performer": {
          "@type": "Person",
          "name": event.performer
        },
        "location": {
          "@type": "Place",
          "name": "Cats About Town Tours",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "New York",
            "addressRegion": "NY",
            "addressCountry": "US"
          }
        },
        "offers": {
          "@type": "Offer",
          "price": price,
          "priceCurrency": "USD",
          "availability": "https://schema.org/InStock",
          "url": event.url
        }
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default EventLocalBusinessSchema;
